import React from 'react';

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  count?: number;
  children: React.ReactNode;
}

/** Felles ramme for seksjonene i varekortet. */
export const SectionCard: React.FC<SectionCardProps> = ({ icon, title, count, children }) => (
  <section className="bg-white rounded-lg shadow-sm p-4 sm:p-5">
    <h2 className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-3">
      <span className="text-gray-500">{icon}</span>
      {title}
      {count !== undefined && count > 0 && (
        <span className="text-xs font-medium px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-600">{count}</span>
      )}
    </h2>
    {children}
  </section>
);
